export default __webpack_public_path__ + "static/media/editIcon.a074371d.png";